var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-timeline-item',{staticClass:"enterprise-public-itinerary-timeline-item",style:(_vm.cssVariables)},[_c('EnterpriseTrackingSidebarItineraryCard',{attrs:{"location":_vm.location,"next-stop-time":_vm.nextStopTime,"total-pickup-and-dropoff-count":_vm.totalPickupAndDropoffCount}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }